import React, { lazy, Suspense } from 'react';
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import './i18n.js'
import "./components/assets/css/style.css";
import "./components/assets/css/responsive.css";
import "./components/assets/css/font-awesome.min.css";
import { Authenticated } from "./components/helper";
import ProtectedPrimaryRoute from "./components/ProtectedPrimaryRoute";

//import PrintTranslations from './pages/PrintTranslations.js';
import Loader from './components/common/loader';
const Login = lazy(() => import('./features/users/login'));
const SearchResults = lazy(() => import('./features/products/searchResults'));

const LogOut = lazy(() => import('./features/users/logOut'));
const Categories = lazy(() => import('./features/products/productInfo'));
const NewProducts = lazy(() => import('./features/products/newProducts'));
const ProductsPDF = lazy(() => import('./pages/productspdf'));
const Home = lazy(() => import('./pages/home'));
const Sitemaintenance = lazy(() => import('./pages/sitemaintenance'));
//const Product = lazy(() => import('./components/products'));
const Products = lazy(() => import('./features/products'));
const Checkoutfree = lazy(() => import('./features/checkout/Checkoutfree'));
const Checkoutpay = lazy(() => import('./features/checkout/Checkout'));
const Thankyou = lazy(() => import('./features/orders/thankyou'));
const Account = lazy(() => import('./features/orders/myOrders'));
const ForgotPassword = lazy(() => import('./features/users/Forgotpassword'));
const Unsubscribe = lazy(() => import('./features/users/unsubscribe.js'))
const CreatePassword = lazy(() => import('./features/users/createPassword.js'));
const ResetPassword = lazy(() => import('./features/users/ResetPassword'));
const ResetCreatePassword = lazy(() => import('./features/users/ResetCreatePassword'));
const Changepassword = lazy(() => import('./features/users/Changepassword'));
const Myaccount = lazy(() => import('./features/users/Myaccount'));
const Terms = lazy(() => import('./components/common/terms'));
const PdfViewer = lazy(() => import('./features/products/pdfviewer.js'));
const Downloads = lazy(() => import('./pages/downloads'));
const MonthlyPromotions = lazy(() => import('./pages/monthlypromotions'));


const VendorLandingCMS = lazy(() => import('./pages/vendor-landing-cms.js'));
const OrderedItems = lazy(() => import('./features/orders/orderedItems'));
const VerifyVendorEmail = lazy(() => import('./features/users/VerifyVendorEmail.js'));
const FavouiteSetting =lazy(() => import('./features/favourites/favouriteSetting.js'));
const Favourites =lazy(() => import('./features/favourites/favourite.js'));
const NotFound = lazy(() => import('./pages/NotFound'));
/*
import Login from './features/users/login';
import LogOut from './features/users/logOut';
import Categories from './components/categories';
import Home from './pages/home.js';
import Sitemaintenance from './pages/sitemaintenance';
import Product from './components/products';
import Checkout from './components/checkout';
import Checkoutfree from './components/checkout/Checkoutfree';
import Checkoutpay from './components/checkout/Checkout';
import Thankyou from './components/checkout/thankyou';
import Account from './components/account';
import ForgotPassword from './components/account/Forgotpassword';
import ResetPassword from './components/account/ResetPassword';
import Myaccount from './features/users/Myaccount.js';
import Terms from './components/common/terms';
import PdfViewer from './components/checkout/pdfviewer';*/




function App() {
  return (
    <Router >
      <Suspense fallback={<main className="main-section"><Loader propsClassName="load-lag" /> </main>}>
        <Routes>
          <Route path="/" element={<Authenticated />} >
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            
            <Route path='/search' element={<SearchResults />} />
            <Route exact path="offerinfo" element={<Checkoutfree />} />
            <Route exact path="productinfo" element={<Categories />} />
            <Route exact path="newproducts" element={<NewProducts />} />
            <Route exact path="/productspdf/:promoTitle" element={<ProductsPDF />} />
            <Route exact path="terms" element={<Terms />} />
            {/* <Route exact path="products" element={<Product />}  /> */}
            <Route exact path="downloads" element={<Downloads />} />
            
            <Route exact path="monthlypromotions" element={<MonthlyPromotions/>} />
            <Route path="product/:name" element={<Products />} />
            <Route exact path="search-results" element={<SearchResults />} />
            <Route exact path="ordered-items" element={<OrderedItems />} />
            <Route exact path="checkoutpay" element={<Checkoutpay />} />
            <Route exact path="thankyou" element={<Thankyou />} />
            <Route exact path="account" element={<Account />} />
            <Route exact path="myaccount" element={<Myaccount />} />
            <Route exact path="changepassword" element={<ProtectedPrimaryRoute><Changepassword /></ProtectedPrimaryRoute> } />
            <Route exact path="PdfViewer" element={<PdfViewer />} />
            <Route path="/favourites" element={<Favourites />} >
             <Route path="settings" element={<FavouiteSetting />} />
            </Route>
          </Route>
          <Route exact path="sitemaintenance" element={<Sitemaintenance />} />
          <Route exact path ="/food-service-partner" element={<VendorLandingCMS />} />
          <Route path="/vendor/verify-email" element={<VerifyVendorEmail />} />
          <Route path="/resetpassword/:token/:userid" element={<ResetPassword />} />
          <Route path="/createpassword/:token/:userid" element={<ResetCreatePassword />} />
          <Route exact path="forgot-password" element={<ForgotPassword />} />
          <Route path="/unsubscribe/:emailType/:userId" element={<Unsubscribe />} />
          <Route exact path="create-password" element={<CreatePassword />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/logout" element={<LogOut />} />
          <Route path="*" element={<NotFound />} />
          {/* <Route exact path="/printenjson" element={<PrintTranslations />} /> */}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
